var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4329,
    cy: 2.56672,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.88117,
    cy: 2.56672,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9857,
    cy: 2.56672,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.32844,
    cy: 9.67121,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.77619,
    cy: 9.67121,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.88117,
    cy: 9.67121,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.32844,
    cy: 13.2239,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.77619,
    cy: 13.2239,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0906,
    cy: 13.2239,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5384,
    cy: 13.2239,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.88117,
    cy: 20.3289,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.32844,
    cy: 20.3289,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.32844,
    cy: 16.7762,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.77619,
    cy: 16.7762,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.88117,
    cy: 16.7762,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5384,
    cy: 16.7762,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9857,
    cy: 16.7762,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0906,
    cy: 16.7762,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9857,
    cy: 20.3289,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4329,
    cy: 20.3289,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5384,
    cy: 20.3289,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4329,
    cy: 23.8807,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4329,
    cy: 27.4334,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.88117,
    cy: 23.8807,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9857,
    cy: 23.8807,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5384,
    cy: 9.67121,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9857,
    cy: 9.67121,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0906,
    cy: 9.67121,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4329,
    cy: 6.11945,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.88117,
    cy: 6.11945,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.32844,
    cy: 6.11945,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9857,
    cy: 6.11945,
    r: 1.77619,
    fill: "#1C1D1F"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5384,
    cy: 6.11945,
    r: 1.77619,
    fill: "#1C1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.139cf7c202215448c2bcea2d9fc027d8.svg";
export { ForwardRef as ReactComponent };